<div class="ticket-card">
  <div class="ticket-title-area">
    <i class="pi pi-ticket"></i>
    <span> {{ ticket.title }}</span>
  </div>
  <div class="porter-title-area">
    <div class="icon-label">
      <i class="pi pi-user"></i>
      <b> Portador:</b>
    </div>
  </div>
  <div class="porter-info-area">
    <div class="user-info">
      @if (hasUserInfo() && !isTransfer()) {
        <p><b>Nome: </b> {{ ticket.user_name }} {{ ticket.user_last_name }}</p>
        <p><b>E-mail: </b> {{ ticket.user_email }}</p>
      } @else {
        <div class="icon-label">
          <i class="pi pi-exclamation-circle"></i>
          <span class="no-porter"> {{ getTicketStatus() }} </span>
        </div>
      }
    </div>
  </div>
  @if (ticket.transferred_from) {
    <div class="transfer-origin-area">
      <div class="icon-label">
        <i class="pi pi-send"></i>
        <b>Recebido via transferência de:</b>
      </div>
      <div class="origin-info">
        @if (ticket.transfer_origin_name) {
          <p>{{ ticket.transfer_origin_name }}</p>
        }
        @if (ticket.transfer_origin_email) {
          <p>{{ ticket.transfer_origin_email }}</p>
        }
      </div>
    </div>
  }
  @if (ticket.status === TicketStatusEnum.TransferInProgress && ticket.recipient_email) {
    <div class="transfer-origin-area">
      <div class="icon-label">
        <i class="pi pi-send"></i>
        <b>Transferência pendente para:</b>
      </div>
      <div class="origin-info">
        <p>{{ ticket.recipient_email }}</p>
      </div>
    </div>
  }
  @if (ticket.status === TicketStatusEnum.Transferred) {
    <div class="transfer-origin-area">
      <div class="icon-label">
        <i class="pi pi-send"></i>
        <b>Transferido para:</b>
      </div>
      <div class="origin-info">
        <p>{{ ticket.transferred_to_name }}</p>
        <p>{{ ticket.transferred_to_email }}</p>
      </div>
    </div>
  }
  <div class="actions-area">
    @if (!restrictToEventAction && !eventDateHasPassed() && ticket.status !== TicketStatusEnum.PaymentNotCompleted) {
      @if (!isTransfer()) {
        @if (hasUserInfo()) {
          <app-button (btnClick)="openTicketInfoModal(ticket)" styleType="outlined">
            <i class="pi pi-print"></i> Imprimir Ingresso
          </app-button>
          <app-button (btnClick)="downloadTicketPdf()" styleType="outlined">
            <i class="pi pi-download"></i> Baixar PDF
          </app-button>
        } @else {
          <app-button (click)="openAssignModal(ticket)" styleType="outlined">
            <i class="pi pi-plus"></i> Cadastrar Portador
          </app-button>
        }
      }
      @if (ticket.transferable) {
        @if (ticket.status === TicketStatusEnum.TransferInProgress) {
          <app-button (btnClick)="revokeTransfer()" styleType="outlined">
            <i class="pi pi-times-circle"></i> Revogar transferência
          </app-button>
        } @else if (ticket.status !== TicketStatusEnum.Transferred) {
          <app-button
            styleType="outlined"
            (btnClick)="openTransferModal(ticket)"
            [disabled]="eventDateHasPassed() || transferWindowClosed()">
            <i class="pi pi-send"></i> Transferir ingresso
          </app-button>
        }
      }
    }
    <app-button (click)="goToEvent(ticket.event_id)"> <i class="pi pi-external-link"></i> Página do evento </app-button>
  </div>
</div>

@if (loading) {
  <app-loading />
}
